import React from "react";
import { Link } from "react-router-dom";
import { NoIndex } from "../components/SEO";
import { Home, Stethoscope, BookOpen, Mail } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] bg-bone flex items-center justify-center px-6 py-16" data-testid="not-found-page">
      <NoIndex title="Page not found — Dr. Tania Gurdip Singh"/>
      <div className="max-w-2xl text-center">
        <div className="mono text-[10px] uppercase tracking-[0.28em] text-prestige">404</div>
        <h1 className="font-serif text-5xl md:text-6xl text-navy mt-4 tracking-tight leading-[1.05]">
          This page has moved on.
        </h1>
        <div className="h-px w-12 bg-prestige mx-auto my-8"/>
        <p className="text-lg text-stone2 leading-relaxed">
          We couldn't find what you were looking for. It may have been renamed, retired, or
          the link may be slightly off. A few useful places to head next:
        </p>
        <div className="mt-10 grid sm:grid-cols-2 gap-3 max-w-lg mx-auto text-left">
          <Link to="/" data-testid="nf-home" className="bg-white border border-line hover:border-navy p-4 group transition-colors duration-300">
            <div className="flex items-center gap-2 text-navy">
              <Home size={16} strokeWidth={1.5}/>
              <span className="font-serif text-lg group-hover:underline underline-offset-4">Home</span>
            </div>
            <p className="text-xs text-stone2 mt-1">Overview of the practice.</p>
          </Link>
          <Link to="/conditions" data-testid="nf-conditions" className="bg-white border border-line hover:border-navy p-4 group transition-colors duration-300">
            <div className="flex items-center gap-2 text-navy">
              <Stethoscope size={16} strokeWidth={1.5}/>
              <span className="font-serif text-lg group-hover:underline underline-offset-4">Conditions library</span>
            </div>
            <p className="text-xs text-stone2 mt-1">Structured overviews of every condition.</p>
          </Link>
          <Link to="/articles" data-testid="nf-articles" className="bg-white border border-line hover:border-navy p-4 group transition-colors duration-300">
            <div className="flex items-center gap-2 text-navy">
              <BookOpen size={16} strokeWidth={1.5}/>
              <span className="font-serif text-lg group-hover:underline underline-offset-4">Articles</span>
            </div>
            <p className="text-xs text-stone2 mt-1">Long-form writing by Dr. Tania.</p>
          </Link>
          <Link to="/contact" data-testid="nf-contact" className="bg-white border border-line hover:border-navy p-4 group transition-colors duration-300">
            <div className="flex items-center gap-2 text-navy">
              <Mail size={16} strokeWidth={1.5}/>
              <span className="font-serif text-lg group-hover:underline underline-offset-4">Get in touch</span>
            </div>
            <p className="text-xs text-stone2 mt-1">Book an appointment or send a message.</p>
          </Link>
        </div>
        <p className="text-xs text-stone2 mt-10">
          If you followed a link from another site,{" "}
          <Link to="/contact" className="text-navy underline underline-offset-4 hover:text-terracotta" data-testid="nf-report">let us know</Link>{" "}
          so we can restore it.
        </p>
      </div>
    </div>
  );
}
